/* eslint-disable no-underscore-dangle */
let contentfulKey
let contentfulSpace
let saltUrl
let merchantId
let paymentTokenValue
let EPSscriptURL
let isLocalTesting
let siteKey
let processEnv

if (Object.keys(process.env).length === 0 || process.env.BROWSER) {
  contentfulKey = window.__SERVER_DATA_.KPREAP_CONTENTFUL_KEY || ''
  contentfulSpace = window?.__SERVER_DATA_?.KPREAP_CONTENTFUL_SPACE || ''
  saltUrl = window?.__SERVER_DATA_?.KPREAP_SALT_URL || ''
  merchantId = window?.__SERVER_DATA_?.KPREAP_SALT_MERCHANT || ''
  paymentTokenValue = window?.__SERVER_DATA_?.KPREAP_SALT_TOKEN || ''
  EPSscriptURL = window?.__SERVER_DATA_?.EPS_SCRIPT_URL || ''
  isLocalTesting = window?.__SERVER_DATA_?.LOCAL_TESTING || ''
  siteKey = window?.__SERVER_DATA_?.RECAPTCHA_SITE_KEY || ''
  processEnv = window?.__SERVER_DATA_?.ENV_APP === 'productionmvne' ? 'production' : ''
} else {
  // This will only happen on the server side
  contentfulKey = process.env.KPREAP_CONTENTFUL_KEY || ''
  contentfulSpace = process?.env?.KPREAP_CONTENTFUL_SPACE || ''
  saltUrl = process?.env?.KPREAP_SALT_URL || ''
  merchantId = process?.env?.KPREAP_SALT_MERCHANT || ''
  paymentTokenValue = process?.env?.KPREAP_SALT_TOKEN || ''
  EPSscriptURL = process?.env?.EPS_SCRIPT_URL || ''
  isLocalTesting = process?.env?.LOCAL_TESTING || ''
  siteKey = process?.env?.RECAPTCHA_SITE_KEY || ''
  processEnv = process?.env?.ENV_APP === 'productionmvne' ? 'production' : ''
}

// const planMfeBffBaseUrl = 'https://staging.www.koodomobile.com/prepaid/mfe'
// const planMfeBffBaseUrl = 'https://digital-mvne-plan-mfe-prepaid-digital-plan-mfe.pr.gke.telus.digital'
const planMfeBffBaseUrl = 'https://www.koodomobile.com/prepaid/mfe'
const planMfeRemoteUrl =
  'https://assets.koodomobile.com/1277136507/prepaid-digital-plan-mfe/v1/mf2/remoteEntry.js'


const contentful = {
  accessToken: contentfulKey,
  spaceId: contentfulSpace,
  environmentId: 'production-v2'
}

const googleReCaptchaConfig = {
  siteUrl: 'https://www.google.com/recaptcha/api/siteverify',
  siteKey
}

let backendUrl = 'https://preview.www.koodomobile.com'

const locale = {
  cookieDomain: '.koodomobile.com'
}

if (isLocalTesting === 'ON') {
  backendUrl = 'http://local.publicmobile.ca:3000'
  locale.cookieDomain = '.publicmobile.ca'
}

const partnerCookieId = 'partnerCache'

const cookieSecure = true

const tagManager =
  '//assets.adobedtm.com/a2962fe01e14/ec556f4805a8/launch-02f63a92b861.min.js'

const paymentConfig = {
  registrationUrl: saltUrl,
  merchantId
}

const paymentToken = paymentTokenValue

export default {
  contentful,
  backendUrl,
  partnerCookieId,
  tagManager,
  paymentConfig,
  locale,
  planMfeBffBaseUrl,
  planMfeRemoteUrl,
  processEnv,
  EPSscriptURL,
  paymentToken,
  cookieSecure,
  googleReCaptchaConfig
}
